import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Dropdown } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';

class Customer extends React.Component {

  state = {
    customerOption: []
  }

  componentDidMount() {
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    context.setState({ load: true, message: 'Getting Customer type' })
    let cook = (ReadCookie("vaigai"));
    let executiveId = cook.id;
    $.ajax({
      type: 'POST', data: { executiveId },
      url: Server() + 'customer/getallcustomer.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setAllCustomerType(data);
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setAllCustomerType(data) {
    let context = this;
    var customer = [];
    data.map((y) => {
      let text = y.id+"-->"+y.name+"->"+y.taluk;
      customer.push({key: text, text: text, value: y.id});
    });
    this.setState({ customerOption: customer, customers: data, load: false });
  }

  customer = (f, { value }) => {
    this.setState({ customer: value });
    this.props.update(value, this.state.customers);
  }

  dataClear() { this.setState({ customer: '' }); }

  render() {
    return (
      <div>
        <Dropdown placeholder='Customer' style={{ borderColor: '#5A9CBB' }}
         fluid search selection onChange={this.customer}
         options={this.state.customerOption} value={this.state.customer} />
      </div>
    );
  }
}

export default Customer;
